import classNames from "classnames";
import { useUser } from "../../hooks/User";
import { Avatar } from ".";
import "./userAvatar.scss";

interface UserAvatarProps {
  squared: boolean;
  size: "sm" | "md" | "lg" | "xl";
}

export const UserAvatar = ({ size, squared }: UserAvatarProps) => {
  const avatarUrl = useUser().getDataByAttributeName("imageUrl");

  return (
    <div className={classNames("userAvatarWrapper", size, { squared: "squared" })}>
      <Avatar url={avatarUrl} />
    </div>
  )
}